import React, {Component} from 'react'
import {Nav, NavDropdown, NavItem, MenuItem} from 'react-bootstrap'

export default class DocumentsTopBar extends Component {
    constructor(props) {
        super(props)
    }

    handleNavSelect = (eventKey, event) => {
        event.preventDefault();
        switch (eventKey) {
            case 'allDocuments':
                window.location.href = '/documents';
                break;
            case 'calendar':
                window.location.href = '/documents?documentType=calendar';
                break;
            case 'deletedCalendars':
              window.location.href = '/documents?documentType=deletedCalendars';
              break;
            case 'myClipArt':
                window.location.href = '/myClipsArts';
                break;
            case 'newletter':
                window.location.href = '/documents?documentType=newletter';
                break;
            case 'calendar_template':
                window.location.href = '/documents?documentType=calendar_template';
                break;
            case 'newletter_template':
                window.location.href = '/documents?documentType=newletter_template';
                break;
            case 'editInstructions':
                window.location.href = '/tooltips/edit';
                break;
            case 'newCalendar':
                window.location.href = '/editor/calendar';
                break;
            case 'newNewsletter':
                window.location.href = '/editor/newsletter';
                break;
            case 'newCalendarTemplate':
                window.location.href = '/editor/calendar?createTemplate=true';
                break;
            case 'newNewsletterTemplate':
                window.location.href = '/editor/newsletter?createTemplate=true';
                break;
            case 'refreshClipArtProcess':
                window.location.href = '/clipArts';
                break;
            case 'inAppMessage':
                window.location.href = '/inAppMessage';
                break;
            case 'help':
                window.open('https://help.activityconnection.com/', '_blank');
                break;
        }
    }

    render = () => {
        return (
            <div className="ac-toolbar ac-toolbar-top-menu document--list-main">
                <Nav bsStyle="pills" stacked onSelect={this.handleNavSelect}>
                    <NavItem className="brand"><img src="/img/ac-55x46.png"/><span>My Documents</span></NavItem>
                    {
                        !this.props.currentUser.isAdmin ?
                            <li className="btn--new dropdown">
                                <a id="new-documents-nav" role="button" className="dropdown-toggle" aria-haspopup="true"
                                   aria-expanded="false"
                                   href="/editor/calendar">New Calendar</a>
                            </li>
                            :
                            <NavDropdown title="New" id="new-documents-nav" className="btn--new">
                                <MenuItem eventKey="newCalendar">
                                    <i className="ma material-icons">event_note</i>
                                    New Calendar</MenuItem>
                                {
                                    this.props.currentUser.isAdmin ?
                                        <MenuItem eventKey="newNewsletter"><i className="ma material-icons">subject</i>New
                                            Newsletter</MenuItem>
                                        : null
                                }
                                {
                                    this.props.currentUser.isAdmin ?
                                        <MenuItem className="line" disabled></MenuItem>
                                        : null
                                }
                                {
                                    this.props.currentUser.isAdmin ?
                                        <MenuItem eventKey="newCalendarTemplate">
                                            <i className="ma material-icons">event_note</i>
                                            New Calendar Template</MenuItem>
                                        : null
                                }
                                {
                                    this.props.currentUser.isAdmin ?
                                        <MenuItem eventKey="newNewsletterTemplate">
                                            <i className="ma material-icons">subject</i>
                                            New Newsletter Template</MenuItem>
                                        : null
                                }
                            </NavDropdown>
                    }


                    {
                        this.props.currentUser.isAdmin ?
                            <NavItem eventKey="allDocuments"
                                     className={this.props.documentType == 'all' ? 'active' : null}><i
                                className="ma material-icons">library_books</i><span>All Documents</span></NavItem>
                            : null
                    }
                    <NavItem eventKey="calendar"
                             className={this.props.documentType == 'calendar' ? 'active' : null}><span><i
                        className="ma material-icons">event_note</i>My Calendars</span></NavItem>
                    <NavItem eventKey="deletedCalendars"
                             className={this.props.documentType == 'deletedCalendars' ? 'active' : null}><span><i
                        className="ma material-icons">event_busy</i>Deleted Calendars</span></NavItem>
                    <NavItem eventKey="myClipArt"
                             className={this.props.documentType == 'myClipArt' ? 'active' : null}><span><i
                        className="ma material-icons">library_books</i>My Clipart</span></NavItem>
                    {
                        this.props.currentUser.isAdmin ?
                            <NavItem eventKey="newletter"
                                     className={this.props.documentType == 'newletter' ? 'active' : null}><span><i
                                className="ma material-icons">subject</i>My Newsletters</span></NavItem>
                            : null
                    }
                    {
                        this.props.currentUser.isAdmin ?
                            <NavItem className="line" disabled></NavItem>
                            : null
                    }
                    {
                        this.props.currentUser.isAdmin ?
                            <NavItem eventKey="calendar_template"
                                     className={this.props.documentType == 'calendar_template' ? 'active' : null}><span><i
                                className="ma material-icons">event_note</i>Calendar Templates</span></NavItem>
                            : null
                    }
                    {
                        this.props.currentUser.isAdmin ?
                            <NavItem eventKey="newletter_template"
                                     className={this.props.documentType == 'newletter_template' ? 'active' : null}><span><i
                                className="ma material-icons">subject</i>Newsletter Templates</span></NavItem>
                            : null
                    }
                    {
                        this.props.currentUser.isAdmin ?
                            <NavItem eventKey="editInstructions" className={this.props.documentType == 'editInstructions' ? 'active' : null}>
                              <span><i className="ma material-icons">description</i>Edit Instructions</span>
                            </NavItem>
                            : null
                    }
                    {
                        this.props.currentUser.isAdmin ?
                            <NavItem className="line" disabled></NavItem>
                            : null
                    }

                    {
                        this.props.currentUser.isAdmin ?
                            <NavDropdown id="administration-nav"
                                         title={
                                             <span><i className="ma material-icons">person</i>Administration</span>
                                         }>
                                <MenuItem eventKey="refreshClipArtProcess"><i
                                    className="ma material-icons">library_books</i>Clip Art</MenuItem>
                                <MenuItem eventKey="inAppMessage"
                                         className={this.props.documentType == 'inAppMessage' ? 'active' : null}><span><i
                                    className="ma material-icons">subject</i>In App Message</span></MenuItem>
                            </NavDropdown>
                            : null
                    }

                    <NavItem className="line" disabled></NavItem>
                    <NavItem eventKey="help"><i className="ma material-icons">help</i>Help!</NavItem>
                </Nav>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/DocumentsTopBar.jsx